import PlayStore from "../Assets/Image/PlayStore.png";
import AppleStore from "../Assets/Image/AppleStore.png";
import AppPix from "../Assets/Image/AppPix.png";

export const DownloadAppAds = () => {
  return (
    <div className="flex flex-col md:flex-row gap-4 pl-4 lg:pl-16 pt-6 my-8 bg-f-bk rounded-lg items-center">
      <div className="lg:w-1/2 flex gap-6 flex-col">
        <h2 className="font-semibold text-2xl">
          Download Loyaltyview <br />
          Mobile App.
        </h2>
        <p className="lg:max-w-[390px]">
          You can download the loyaltyview mobile application by clicking either
          of the icon that specifies your device app store.
        </p>
        <div className="flex flex-row gap-6 w-2/5 lg:w-1/2 lg:max-w-[160px]">
          <img src={PlayStore} alt="playstoore logo" />
          <img src={AppleStore} alt="AppleStore logo" />
        </div>
      </div>
      <div className="w-9/12 lg:w-1/2">
        <img src={AppPix} alt="mobile app image" />
      </div>
    </div>
  );
};
